var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('bc-navbar-user'),_c('b-container',{staticClass:"content-spacer-lg"},[_c('router-view')],1),_c('bc-footer-user')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }